
class RewardsCoupon extends HTMLElement {

  constructor() {
    super();


  }

  static get observedAttributes() {
    return ['title', 'expiresAt', 'code'];
  }

  connectedCallback() {
    const template = document.getElementById('rewards-coupon-template');
    const node = document.importNode(template.content, true);
    this.appendChild(node);
    this.render();
  }

  render() {
    this.querySelector('slot[name="title"]').innerHTML = `<p style="font-size: 100%;font-weight:500;">${this.title}</p>`;
    this.querySelector('slot[name="expiresAt"]').innerHTML = `<p style="font-size: 75%">${this.expiresAt}</p>`;
    this.querySelector('slot[name="code"]').innerHTML = `
      <button class="button" style="width: 12ch">${this.code}</button>
    `
  }


  get title(){
    return this.getAttribute('title' || undefined);
  }

  set title(val) {
    if (val) {
      return this.setAttribute('title', val);
    }
  }

  get expiresAt(){
    return this.getAttribute('expiresAt' || undefined);
  }

  set expiresAt(val) {
    if (val) {
      return this.setAttribute('expiresAt', val);
    }
  }

  get code(){
    return this.getAttribute('code' || undefined);
  }

  set code(val) {
    if (val) {
      return this.setAttribute('code', val);
    }
  }

  get couponId() {
    return this.getAttribute('couponId') || 0;
  }

  set couponId(val) {
    return this.setAttribute('couponId', val);
  }

  get type() {
    return this.getAttribute('type') || undefined;
  }

  set type(val) {
    return this.setAttribute('type', val);
  }

  get couponType() {
    return this.getAttribute('couponType') || undefined;
  }

  set couponType(val) {
    return this.setAttribute('couponType', val);
  }


  get alert() {
    return this.getAttribute('alert') || undefined;
  }

  set alert(val) {
    return this.setAttribute('alert', val);
  }


}

customElements.define('rewards-coupon', RewardsCoupon);